/* eslint-disable no-inline-comments */
const blockList = [
  {
    name: 'social-media',
    fileName: 'SocialMedia'
    // mobile: false
    // hasMobileBlock: false
  },
  {
    name: 'b-related-products',
    fileName: 'RelatedProducts'
  },
  {
    name: 'b-contact',
    fileName: 'Contact'
  },
  {
    name: 'b-modular-banner',
    fileName: 'ModularBanner'
  },
  {
    name: 'b-accordions-list',
    fileName: 'AccordionsList'
  },
  {
    name: 'b-two-columns',
    fileName: 'TwoColumns'
  },
  {
    name: 'b-redirection',
    fileName: 'Redirection'
  },
  {
    name: 'b-hero-banner',
    fileName: 'HeroBanner'
  },
  {
    name: 'b-key-figures',
    fileName: 'KeyFigures'
  },
  {
    name: 'b-steps-horizontal',
    fileName: 'StepsHorizontal'
  },
  {
    name: 'b-hover-cards',
    fileName: 'HoverCards'
  },
  {
    name: 'b-slider-hover-cards',
    fileName: 'SliderHoverCards'
  },
  {
    name: 'b-slider-cards',
    fileName: 'SliderCards'
  },
  {
    name: 'b-slider-cards-bis',
    fileName: 'SliderCardsBis'
  },
  {
    name: 'b-video-list',
    fileName: 'VideoList'
  },
  {
    name: 'jobs',
    fileName: 'Jobs'
  },
  {
    name: 'b-gmaps',
    fileName: 'Gmaps'
  },
  {
    name: 'b-timeline',
    fileName: 'Timeline'
  },
  {
    name: 'b-slider-clouds',
    fileName: 'SliderClouds'
  },
  {
    name: 'b-text-image-links',
    fileName: 'TextImageLinks'
  },
  {
    name: 'b-our-services',
    fileName: 'OurServices'
  }
]

export default blockList
